import * as moment from "moment";
import { getFormattedDate } from "@/utils/datetime";

export const parseVigenciaToForm = value => {
  if (!value) return null;
  return getFormattedDate(value, false, true);
};

export const normalizeVigenciaForSubmit = value => {
  if (!value) return null;
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("YYYY-MM-DDTHH:mm:ssZ") : null;
};

export const isVigenciaIntervaloValido = (inicio, fim) => {
  if (!inicio || !fim) return true;
  return moment(inicio).isSameOrBefore(moment(fim));
};

export const formatVigenciaForDisplay = value => {
  if (value == null || value === "") return "-";
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("DD/MM/YYYY HH:mm:ss") : "-";
};
